import { Link } from "react-router-dom";
import { TrendingUp, Zap, DollarSign, Wrench, Bookmark, ArrowUpRight } from "lucide-react";
import { scoreColor } from "@/components/ScoreMeter";

export default function OpportunityCard({ opp, saved, onSave, compareMode, selected, onToggleCompare }) {
  const color = scoreColor(opp.overall_score);
  const s = opp.scores || {};
  return (
    <div className="glass rounded-xl p-5 card-hover relative flex flex-col" data-testid={`opportunity-card-${opp.slug}`}>
      <div className="flex items-start justify-between gap-3 mb-3">
        <div className="flex items-center gap-2 flex-wrap">
          <span className="text-[11px] font-mono uppercase tracking-wider text-cyan-400 px-2 py-0.5 rounded bg-cyan-500/10 border border-cyan-500/20">{opp.category}</span>
          {opp.trending && <span className="text-[11px] font-mono text-emerald-400 flex items-center gap-1"><TrendingUp className="w-3 h-3" />Trending</span>}
          {opp.is_new && <span className="text-[11px] font-mono text-indigo-400">NEW</span>}
        </div>
        <div className="flex items-center gap-2">
          {compareMode && (
            <input type="checkbox" checked={selected} onChange={() => onToggleCompare?.(opp)} data-testid={`compare-check-${opp.slug}`}
              className="w-4 h-4 accent-cyan-500" />
          )}
          <button onClick={(e) => { e.preventDefault(); onSave?.(opp); }} data-testid={`save-btn-${opp.slug}`}
            className={`p-1.5 rounded-lg border transition-colors ${saved ? "text-cyan-400 border-cyan-500/40 bg-cyan-500/10" : "text-slate-500 border-white/10 hover:text-cyan-400"}`}>
            <Bookmark className="w-4 h-4" fill={saved ? "currentColor" : "none"} />
          </button>
        </div>
      </div>

      <Link to={`/opportunities/${opp.slug}`} className="flex-1">
        <div className="flex items-start gap-4">
          <div className="flex-1">
            <h3 className="text-lg font-semibold text-slate-100 leading-snug mb-1.5 hover:text-cyan-300 transition-colors">{opp.title}</h3>
            <p className="text-sm text-slate-400 line-clamp-2 mb-3">{opp.description}</p>
          </div>
          <div className="shrink-0 text-center">
            <div className="w-14 h-14 rounded-xl border flex flex-col items-center justify-center" style={{ borderColor: `${color}55`, background: `${color}15` }}>
              <span className="font-mono font-bold text-lg leading-none" style={{ color }}>{opp.overall_score}</span>
              <span className="text-[8px] uppercase tracking-wider text-slate-500 mt-0.5">Score</span>
            </div>
          </div>
        </div>
      </Link>

      <div className="grid grid-cols-4 gap-2 mt-auto pt-3 border-t border-white/8">
        <Metric icon={Zap} label="Demand" value={s.demand} />
        <Metric icon={DollarSign} label="Money" value={s.monetization} />
        <Metric icon={Wrench} label="Build" value={s.build_difficulty} />
        <Metric icon={TrendingUp} label="Trend" value={s.trend_velocity} />
      </div>
      <div className="flex items-center justify-between mt-3 text-xs text-slate-500">
        <span className="font-mono">{opp.pricing}</span>
        <Link to={`/opportunities/${opp.slug}`} className="flex items-center gap-1 text-cyan-400 hover:gap-2 transition-all" data-testid={`view-btn-${opp.slug}`}>
          View <ArrowUpRight className="w-3.5 h-3.5" />
        </Link>
      </div>
    </div>
  );
}

function Metric({ icon: Icon, label, value = 0 }) {
  const color = scoreColor(value);
  return (
    <div className="text-center">
      <Icon className="w-3.5 h-3.5 mx-auto mb-1 text-slate-500" />
      <div className="font-mono text-sm font-bold" style={{ color }}>{value}</div>
      <div className="text-[9px] uppercase tracking-wide text-slate-600">{label}</div>
    </div>
  );
}
